<template>
  <header @click="toggleGroup" :class="{ pointer: showToggle }">
    <h1>{{ menuGroup.title }}<span v-if="!menuGroup.subTitle">:</span></h1>
    <h2 v-if="menuGroup.subTitle">{{ menuGroup.subTitle }}:</h2>
    <div v-if="attachedFileName">
      {{ attachedFileName }}
    </div>
    <div
      v-for="spec in selectedSpecs"
      :key="spec.optionTitle"
      :class="{ 'comment-title': spec.optionGroupName === 'opmerking' }"
    >
      <span v-if="spec.optionGroupName === 'opmerking' && !spec.optionTitle"
        >Geen opmerking</span
      >
      <span v-if="spec.optionGroupName === 'datePicker'">{{
        spec.optionTitle
      }}</span>
      <span v-else>{{ spec.optionTitle }}</span>
    </div>

    <span v-if="hasRequiredMissing" class="required-warning error-text"
      >Dit veld is verplicht</span
    >

    <img
      v-if="showToggle"
      src="@/images/icons/chevron-left-solid.svg"
      class="open-image"
      :class="{ open: open }"
    />
  </header>
</template>

<script>
export default {
  name: 'MenuGroupHeader',
  props: {
    menuGroup: {
      type: Object,
      required: true
    },
    selectedSpecs: {
      type: Array,
      required: true
    },
    selectedFiles: {
      type: Array,
      required: true
    },
    open: {
      type: Boolean,
      required: true
    },
    showToggle: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    hasRequiredMissing() {
      return this.menuGroup.optionGroups?.some((og) => {
        if (!og.required) return false
        const spec = this.selectedSpecs.find(
          (s) => s.optionGroupName === og.name
        )
        return !spec || !spec.optionTitle
      })
    },
    attachedFileName() {
      if (
        this.selectedFiles[0].productSpecs.files?.some(
          (file) => file.type === this.menuGroup.fileTypeRequired
        )
      ) {
        return this.selectedFiles[0].productSpecs.files.find(
          (file) => file.type === this.menuGroup.fileTypeRequired
        ).name
      }
    }
  },
  methods: {
    toggleGroup() {
      if (this.showToggle) this.$emit('toggle')
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  padding: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  h1,
  h2 {
    font-size: 0.82rem;
    font-weight: 600;
    color: var(--text-color);
    margin: 0;
  }

  h2 {
    padding-left: 10px;
  }

  & > div {
    &:first-of-type {
      padding-left: 10px;
    }

    &.comment-title {
      max-width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    padding-left: 15px;
    font-weight: 500;
  }

  .required-warning {
    margin-left: auto;
    margin-right: 8px;
    font-size: 0.85rem;
    font-weight: 600;
    flex-shrink: 0;

    & + .open-image {
      margin-left: 0;
    }
  }

  .open-image {
    width: 15px;
    height: 15px;
    margin-left: auto;
    flex-shrink: 0;
    transition: transform 0.4s;

    &.open {
      transform: rotate(-90deg);
    }
  }
}
</style>
